import React from 'react';
import { usePetContext } from '@/context/PetContext';
import { useAppointments } from '@/hooks/useAppointments';
import NotificationsHandler from './notification';

const NotificationWrapper: React.FC = () => {
  const { pets } = usePetContext();
  const { appointments } = useAppointments();

  return (
    <NotificationsHandler
      appointments={appointments}
      pets={pets}
    />
  );
};

export default NotificationWrapper;
